// Uygulamanin desteklediği dillerin tek kaynagi.
// Buraya bir satir eklemek yetmez; lngProvider/entries altina karsilik gelen
// dosyayi da ekleyip lngProvider/index.js icinde kaydetmek gerekir.
const languageData = [
  {
    languageId: 'turkish',
    locale: 'tr',
    name: 'Türkçe',
    icon: 'tr',
    flag: '🇹🇷'
  },
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us',
    flag: '🇺🇸'
  },
  {
    languageId: 'spanish',
    locale: 'es',
    name: 'Español',
    icon: 'es',
    flag: '🇪🇸'
  },
  {
    languageId: 'japanese',
    locale: 'ja',
    name: '日本語',
    icon: 'jp',
    flag: '🇯🇵'
  },
  {
    languageId: 'chinese',
    locale: 'zh',
    name: '中文',
    icon: 'cn',
    flag: '🇨🇳'
  },
  {
    languageId: 'portuguese',
    locale: 'pt',
    name: 'Português',
    icon: 'pt',
    flag: '🇵🇹'
  },
  {
    languageId: 'saudi-arabia',
    locale: 'ar',
    name: 'العربية',
    icon: 'sa',
    flag: '🇸🇦',
    rtl: true
  },
  {
    languageId: 'russian',
    locale: 'ru',
    name: 'Русский',
    icon: 'ru',
    flag: '🇷🇺'
  },
  {
    languageId: 'indonesian',
    locale: 'id',
    name: 'Bahasa Indonesia',
    icon: 'id',
    flag: '🇮🇩'
  },
  {
    languageId: 'french',
    locale: 'fr',
    name: 'Français',
    icon: 'fr',
    flag: '🇫🇷'
  },
  {
    languageId: 'german',
    locale: 'de',
    name: 'Deutsch',
    icon: 'de',
    flag: '🇩🇪'
  },
  {
    languageId: 'italian',
    locale: 'it',
    name: 'Italiano',
    icon: 'it',
    flag: '🇮🇹'
  },
  {
    languageId: 'hindi',
    locale: 'hi',
    name: 'हिन्दी',
    icon: 'in',
    flag: '🇮🇳'
  },
  {
    languageId: 'azerbaijani',
    locale: 'az',
    name: 'Azərbaycanca',
    icon: 'az',
    flag: '🇦🇿'
  }
];
export default languageData;
